import TableErrorComponent from './tableErrorComponent';

export default TableErrorComponent;
